module.exports = __webpack_public_path__ + "static/media/manam-icon.59cb7bf9.svg";